import { service } from '@ember/service';
import Component from '@glimmer/component';

import FileUploader from 'umg-ember-backend/components/ui/file-uploader';

export default class AssetToolsReplaceComponent extends Component {
  // Services
  @service flashMessages;
  @service fetch;
  @service store;

  // Functions
  updateVideoAsset = async (file) => {
    try {
      const response = await this.fetch.post('/tools/updateVideoAsset', {
        data: {
          asset: this.args.asset.id,
          tmpAssetName: file.uploadPath,
        },
      });

      await this.store.pushPayload(response);

      this.flashMessages.success('flash.replace.success');
    } catch (error) {
      const message = error.payload?.errors?.message ?? error;
      this.flashMessages.error(message, {
        rawString: true,
      });
    }
  };

  // Template
  <template>
    <div ...attributes>
      <FileUploader
        @isMultiple={{false}}
        @onSuccess={{this.updateVideoAsset}}
      />
    </div>
  </template>
}
